import { useAppForm } from '@/components/form/formHooks';
import { useFormSchema } from '@/domain/mitarbeiter/features/anlageassistent/hooks/schema/useFormSchema';
import { FormInput } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import { createContext, useContext } from 'react';

type AnlageassistentFormContextType = ReturnType<typeof useAnlageassistentForm>;

const AnlageassistentFormContext =
  createContext<AnlageassistentFormContextType | null>(null);

function useAnlageassistentForm() {
  const FormSchema = useFormSchema();
  return useAppForm({
    defaultValues: {
      person: {
        persoenliches: {
          anrede: '',
          vorname: '',
          nachname: '',
          rufname: undefined,
          personalnummer: undefined,
          e2nId: undefined,
        },
        kontakt: {
          email: undefined,
          mobilnummer: undefined,
          strict: false,
        },
        arbeitsbereiche: {
          primaererArbeitsbereich: '',
          sekundaereArbeitsbereiche: [],
          erfahrungslevel: undefined,
        },
      },
      anstellungsverhaeltnis: {
        anstellung: {
          anstellungstyp: '',
          eintrittsdatum: undefined,
          befristet: false,
          befristung: undefined,
        },
        fristen: [],
      },
      bezahlung: {
        bezahlungsart: {
          art: undefined,
          stundenlohn: '',
          monatsgehalt: undefined,
        },
      },
    } satisfies FormInput as FormInput,
    validators: {
      onSubmit: FormSchema,
    },
    onSubmit: async ({ value }) => {
      // handle mitarbeiter anlegen
      return value;
    },
  });
}

export function AnlageassistentFormProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const form = useAnlageassistentForm();
  return (
    <AnlageassistentFormContext.Provider value={form}>
      {children}
    </AnlageassistentFormContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAnlageassistentFormContext() {
  const context = useContext(AnlageassistentFormContext);
  if (!context) {
    throw new Error('AnlageassistentFormProvider missing');
  }
  return context;
}
